module.exports = __webpack_public_path__ + "static/illustration-500-27c576273c4e7de72d36f42988cdbd94.svg";